const visileColumns = [

   
  // {
  //   title: "Subscriber Id",
  //   field: "SubscriberID",
  //   locked: false,
  //   filter: "text",
  //   width: 200,
  //   show: true,
  // },
  {
    title: "LastName",
    field: "LastName",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },
  {
    title: "FirstName",
    field: "FirstName",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },
  {
    title: "MiddleName",
    field: "MiddleName",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },

  


  {
    title: "DOB",
    field: "DOB",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: 140,
    show: true,
  },
  {
    title: "Age",
    field: "Age",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  {
    title: "Gender",
    field: "Gender",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  
 
  {
    title: "Health Subscriber",
    field: "health_FirstName",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  {
    title: "Dental Subscriber",
    field: "dental_FirstName",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  {
    title: "Posting Status",
    field: "postingFlag",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },

];

export default visileColumns;
